var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-input',{attrs:{"defaultValue":_vm.defaultValue},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }